/**
 * 模块 - 数据中心 - 英文
 */
export default {
  dataCenter: {
    exportReport: 'Export Report',
    agent: 'Agent',
    regionAgent: 'Region Agent',
    pleaseSelectAgent: 'Select agent',
    performanceMonth: 'Performance Month',
    pleaseSelectMonth: 'Select month',
    regionAgentSelectTip: 'Region agents can select all agents within their region',
    agentVersionQueryTip: 'Query historical cumulative purchase volume, activation volume and latest inventory of all agents in the region',
    agentVersionNewQueryTip: 'Query purchase volume, activation volume and latest inventory of all agents in the region for a specific period',
    agentInfo: 'Agent Info',
    agentId: 'Agent ID',
    agentName: 'Agent Name',
    agentLevel: 'Agent Level',
    name: 'Name',
    phone: 'Phone',
    address: 'Address',
    region: 'Region',
    productType: 'Product Type',
    pleaseSelectProductType: 'Select product type',
    purchaseQty: 'Purchase Qty (units)',
    activateQty: 'Activation Qty (units)',
    stockQty: 'Stock Qty (units)',
    dispatchDate: 'Dispatch Date',
    pleaseSelectDispatchDate: 'Select dispatch date',
    orderTime: 'Order Time',
    sendTime: 'Ship Time',
    pleaseSelectSendTime: 'Select dispatch time',
    provinceCityDistrict: 'Province/City/District',
    useTime: 'Use Time',
    agentOrderingTip: 'Note: Order quantity = confirmed region transfer orders + HQ paid orders',
    statisticalCycle: 'Statistical Cycle',
    agentRegion: 'Agent Region',
    orderQty: 'Order Qty',
    provinceCity: 'Province/City',
    pleaseSelectOrderTime: 'Select order time',
    purchaseNo: 'Purchase No.',
    pleaseEnterPurchaseNo: 'Enter purchase no.',
    pleaseSelectMonth: 'Select month',
    query: 'Query',
    pleaseSelectRegionAgent: 'Select region agent',
    orderNo: 'Order No.',
    pleaseEnterOrderNo: 'Enter order no.',
    activateTime: 'Activation Time',
    pleaseSelectActivateTime: 'Select activation time',
    hardwareActiveCnt: 'Hardware Activation Qty',
    softwareActiveCnt: 'Software Activation Qty',
    warehouseName: 'Warehouse',
    hardwareActivateStatus: 'Hardware Activate Status',
    voucherPrice: 'Voucher Price',
    cashPrice: 'Cash Price',
    totalPrice: 'Total Price',
    softwareActivateTime: 'Software Activate Time',
    softwareActivateMonth: 'Software Activate Month',
    firstDispatchTime: 'First Dispatch Time',
    latestPurchaseNo: 'Latest Purchase No.',
    defaultQueryCurrentMonth: 'Default query current month',
    to: 'to',
    time: 'Time',
    pleaseSelectTime: 'Select time',
    dealerId: 'Dealer ID',
    dealerName: 'Dealer Name',
    yearMonth: 'Year/Month',
    crossRegionType: 'Cross Region Type',
    credit: 'Credit',
    reportCnt: 'Report Qty',
    reportActiveCnt: 'Report Active Qty',
    creditBalance: 'Credit Balance',
    reviewCnt: 'Review Qty',
    reviewBadCnt: 'Review Non-compliant Qty',
    lastEmployeeCannotDelete: 'The last employee cannot be deleted',
    deleteFailRetry: 'Delete failed. Please try again',
    pleaseSelectTargetPeriod: 'Please select target period',
    targetCreateSuccess: 'Target created successfully!',
    periodNoTargetQuery: 'Current period has no target set. Some data is 0. You may query a non-cross-month period',
    periodNoTargetSet: 'Current period has no target set. Some data is 0. You may set current month target first',
    querySuccess: 'Query successful',
    avgPriceRequired: 'Average price is required',
    conversionRateRequired: 'Conversion rate is required',
    visitRateRequired: 'Visit rate is required',
    promiseVisitRateRequired: 'Promise visit rate is required',
    addWechatRateRequired: 'Add WeChat rate is required',
    supervisorSignRateRequired: 'Supervisor sign rate is required',
    supervisorAvgPriceRequired: 'Supervisor average price is required',
    saveSuccessExclaim: 'Saved successfully!',
    tipTimeSetSuccess: 'Tip time set successfully',
    // Cloud Warehouse Report
    warehouse: 'Warehouse',
    pleaseSelectWarehouse: 'Select warehouse',
    productName: 'Product Name',
    totalInventory: 'Total Inventory',
    availableInventory: 'Available Inventory',
    partnerCloudWarehouse: 'Partner Cloud Warehouse',
    qu: 'Region',
    type: 'Product Type',
    liang: 'Purchase Qty (units)',
    activate: 'Activation Qty (units)',
    inventory: 'Inventory Qty (units)',
  }  
}
